import React from "react";
import { connect } from "react-redux";
import Category from "./Category";

const mapStateToProps = state => {
    return {
        mediaType: state.appSettings.mediaType
    }
}

class CategoryList extends React.Component {
    render() {
        var content = this.props.content.map((item, key) => {
            return <Category key={key} data={item} mediaType={this.props.mediaType} />;
        });
        
        return <div className="category-list-wrap">
            {content}
        </div>
    }
}

export default connect(mapStateToProps)(CategoryList);